import {AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input} from '@angular/core';

@Component({
  selector: 'app-tooltip-on-text-overflow',
  templateUrl: './tooltip-on-text-overflow.component.html',
  styleUrl: './tooltip-on-text-overflow.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TooltipOnTextOverflowComponent implements AfterContentChecked{
    showTooltip = false;
    @Input({required: true}) tooltipContent ='';

    constructor(private elRef: ElementRef, private _cdr: ChangeDetectorRef) {
    }


    ngAfterContentChecked(): void {
        this.isTextOverflow();
        this._cdr.detectChanges();
    }

    /**
     * Check the element if it is text-overflow
     */
    private isTextOverflow(): boolean {
        const elem = this.elRef?.nativeElement;
        if (elem) {
            this.showTooltip = (elem.offsetWidth < elem.scrollWidth) || (elem.offsetHeight < elem.scrollHeight)

        }
        else {
            this.showTooltip = false
        }

        return this.showTooltip;
    }

}
